import React from 'react';
import { Skeleton, SxProps, Theme } from '@mui/material';

interface TextBoneProps {
    /** Variante de forme du skeleton */
    variant?: 'text' | 'rectangular' | 'rounded' | 'circular';
    /** Variante typographique pour la taille */
    textVariant?:
        | 'h1'
        | 'h2'
        | 'h3'
        | 'h4'
        | 'h5'
        | 'h6'
        | 'subtitle1'
        | 'subtitle2'
        | 'body1'
        | 'body2'
        | 'caption'
        | 'button'
        | 'overline';
    /** Animation */
    animation?: 'pulse' | 'wave' | false;
    /** Styles personnalisés */
    sx?: SxProps<Theme>;
}

// Mappage des variantes typographiques vers des styles
const getTextVariantStyles = (textVariant?: string) => {
    switch (textVariant) {
        case 'h1':
            return { fontSize: '6rem', height: '7rem' };
        case 'h2':
            return { fontSize: '3.75rem', height: '4.5rem' };
        case 'h3':
            return { fontSize: '3rem', height: '3.5rem' };
        case 'h4':
            return { fontSize: '2.125rem', height: '2.5rem' };
        case 'h5':
            return { fontSize: '1.5rem', height: '2rem' };
        case 'h6':
            return { fontSize: '1.25rem', height: '1.75rem' };
        case 'subtitle1':
            return { fontSize: '1rem', height: '1.5rem' };
        case 'subtitle2':
            return { fontSize: '0.875rem', height: '1.25rem' };
        case 'body1':
            return { fontSize: '1rem', height: '1.5rem' };
        case 'body2':
            return { fontSize: '0.875rem', height: '1.25rem' };
        case 'caption':
            return { fontSize: '0.75rem', height: '1rem' };
        case 'button':
            return { fontSize: '0.875rem', height: '1.25rem' };
        case 'overline':
            return { fontSize: '0.75rem', height: '1rem' };
        default:
            return { height: '1.2em' }; // Fallback
    }
};

export const TextBone: React.FunctionComponent<TextBoneProps> = function ({
    variant = 'rounded',
    textVariant = 'text',
    animation = 'pulse',
    sx = {},
}) {
    const textStyles = textVariant ? getTextVariantStyles(textVariant) : {};

    return (
        <Skeleton
            variant={variant}
            animation={animation}
            role="progressbar"
            sx={{
                ...textStyles,
                ...sx,
            }}
        />
    );
};
